<!--
 * @Author: 仙道
 * @Date: 2022-10-26 21:07:10
 * @LastEditTime: 2022-11-07 23:22:17
 * @email: hao.li08@weimob.com
 * @Description: 
 * @FilePath: /iplus-iwt-fe/src/views/equipment/account/modules/components/PendingAlert.vue
-->
<template>
  <div class="c-tabs-panel">
    <i-table :columns="columns" :queryParams="queryParams" :url="url" ref="table"></i-table>
  </div>
</template>

<script>
  import { mapGetters } from 'vuex'
  import { filterDictTextByCache } from '@/components/dict/JDictSelectUtil'

  import ITable from '@/views/workbench/components/Itable.vue'
  export default {
    name: 'PendingAlert',
    components: {
      ITable
    },
    props: {
      deviceData: {
        type: Object,
        default: () => { }
      }
    },
    // 定义属性
    data () {
      return {
        disableMixinCreated: true,
        queryParams: {
        },
        url: '/maintenance/devMaintenanceStlSub/queryStlSubByDevTypeIds',
        columns: [

          {
            title: '保养项目',
            align: 'center',
            dataIndex: 'projectCode',
            customRender: function (text) {
              return filterDictTextByCache('maintaince_type', text)
            }
          },
          {
            title: '部位',
            align: 'center',
            dataIndex: 'maintenancePlace'
          },
          {
            title: '保养操作',
            align: 'center',
            dataIndex: 'maintenanceOperate',

          },
          {
            title: '保养周期',
            align: 'center',
            dataIndex: 'maintenanceIntervals'
          },
          {
            title: '单位',
            align: 'center',
            dataIndex: 'maintenanceUnit',
            customRender: function (text) {
              return filterDictTextByCache('maintaince_timeunit', text)
            }
          },
          {
            title: '计时方式',
            align: 'center',
            dataIndex: 'tickingType',
            customRender: function (text) {
              return filterDictTextByCache('maintaince_timertype', text)
            }
          }
        ],
      }
    },
    // 计算属性，会监听依赖属性值随之变化
    computed: {
      ...mapGetters([''])
    },
    // 监控data中的数据变化
    watch: {},
    // 生命周期 - 创建完成（可以访问当前this实例）
    created () {

      const { devTypeId = '' } = this.deviceData
      this.queryParams = { devTypeId }
    },
    // 生命周期 - 挂载完成（可以访问DOM元素）
    mounted () {

    },
    // 方法集合
    methods: {
      queryData () {
        this.$refs.table.loadData()
      }
    }
  }
</script>

<style lang='scss' scoped>


</style>